/**
 * Plataformas disponíveis no hub de copytrade
 */
export enum CopytradePlatform {
  UniversoElliot = 'universo-elliot'
}

/**
 * Configuração de cada plataforma de copytrade
 */
export interface CopytradePlatformConfig {
  name: CopytradePlatform;
  portfolioTypeId: number;
  label: string;
}

/**
 * Mapeamento das plataformas disponíveis
 */
export const COPYTRADE_PLATFORMS: Record<
  CopytradePlatform,
  CopytradePlatformConfig
> = {
  [CopytradePlatform.UniversoElliot]: {
    name: CopytradePlatform.UniversoElliot,
    portfolioTypeId: 14,
    label: 'Universo Elliot'
  }
};
